import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { RecipientTab } from '../gift-card-purchase.component';
import { GiftCardPurchaseFormService } from '../gift-card-purchase-form/gift-card-purchase-form.service';

@Component({
    selector: 'ols-gift-card-recipient-option',
    templateUrl: './recipient-option.component.html',
    styleUrls: ['./recipient-option.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class RecipientOptionComponent implements OnInit {
    private _selectedTabIndex: RecipientTab;
    public get selectedTabIndex() {
        return this._selectedTabIndex;
    }
    @Input() public set selectedTabIndex(value: RecipientTab) {
        this.switchTabs(value);
        this._selectedTabIndex = value;
    }

    recipientTab = RecipientTab;
    get recipientName() {
        return this.giftCardPurchaseFormService.form.get('recipientName');
    }

    get recipientEmail() {
        return this.giftCardPurchaseFormService.form.get('recipientEmail');
    }

    constructor(
        private giftCardPurchaseFormService: GiftCardPurchaseFormService
    ) {}

    ngOnInit(): void {
        this.switchTabs(this.selectedTabIndex);
    }

    onTabChange(event) {
        this.selectedTabIndex = event.index;
    }

    submitForm() {
        this.giftCardPurchaseFormService.submitForm();
    }

    private switchTabs(index) {
        switch (index) {
            case this.recipientTab.FOR_ME:
                this.giftCardPurchaseFormService.clearRecipientOptionValidators();
                break;
            case this.recipientTab.FOR_SOMEONE_ELSE:
                this.giftCardPurchaseFormService.setRecipientOptionValidators();
                break;
        }
    }
}
